import { z } from 'zod';

/** Which invoice-settings default names this account. */
export const DEFAULT_ACCOUNT_SLOTS = ['retainer', 'service', 'expense', 'discount'] as const;
export type DefaultAccountSlot = (typeof DEFAULT_ACCOUNT_SLOTS)[number];

/** One account in the read-only chart of accounts. */
export const ChartOfAccountSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  accountType: z.enum(['income', 'contra_income']),
  /** Inactive accounts stay on records that already use them but are not
   *  offered in pickers. */
  active: z.boolean(),
  /** Activities pointing at this account as retainer or T&M account. */
  activityCount: z.number().int(),
  /** Invoice-settings defaults that name this account. */
  defaultFor: z.array(z.enum(DEFAULT_ACCOUNT_SLOTS)),
});
export type ChartOfAccount = z.infer<typeof ChartOfAccountSchema>;

/** "4016 Retainer Revenue" — how an account reads everywhere it is shown. */
export function accountLabel(a: Pick<ChartOfAccount, 'code' | 'name'>): string {
  return a.name && a.name !== a.code ? `${a.code} ${a.name}` : a.code;
}
